export default __webpack_public_path__ + "static/media/star-of-life-solid.0572090b.svg";